import { db } from '../firebase';
import { 
  collection, 
  addDoc, 
  query, 
  where, 
  getDocs,
  updateDoc,
  deleteDoc,
  doc 
} from 'firebase/firestore';

// Categorías por defecto
export const DEFAULT_CATEGORIES = [
  { name: 'Alimentación', type: 'egreso', icon: '🍔' },
  { name: 'Transporte', type: 'egreso', icon: '🚗' },
  { name: 'Educación', type: 'egreso', icon: '📚' },
  { name: 'Entretenimiento', type: 'egreso', icon: '🎬' },
  { name: 'Salud', type: 'egreso', icon: '🏥' },
  { name: 'Vivienda', type: 'egreso', icon: '🏠' },
  { name: 'Servicios', type: 'egreso', icon: '💡' },
  { name: 'Otros', type: 'egreso', icon: '📦' },
  { name: 'Salario', type: 'ingreso', icon: '💰' },
  { name: 'Freelance', type: 'ingreso', icon: '💼' },
  { name: 'Inversiones', type: 'ingreso', icon: '📈' },
  { name: 'Otros Ingresos', type: 'ingreso', icon: '💵' }
];

export const createCategory = async (userId, categoryData) => {
  return await addDoc(collection(db, 'categories'), {
    userId,
    ...categoryData,
    createdAt: new Date()
  });
};

export const getCategories = async (userId) => {
  const q = query(collection(db, 'categories'), where('userId', '==', userId));
  const snapshot = await getDocs(q);
  const userCategories = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
  
  // Siempre combinar categorías por defecto con las del usuario
  // Las categorías por defecto no tienen ID, las del usuario sí
  const allCategories = [...DEFAULT_CATEGORIES, ...userCategories];
  
  // Eliminar duplicados por nombre (priorizar las del usuario)
  const uniqueCategories = allCategories.reduce((acc, current) => {
    const exists = acc.find(cat => cat.name === current.name);
    if (!exists) {
      acc.push(current);
    } else if (current.id) {
      // Si existe y la actual tiene ID (es del usuario), reemplazar
      const index = acc.findIndex(cat => cat.name === current.name);
      acc[index] = current;
    }
    return acc;
  }, []);
  
  return uniqueCategories;
};

export const updateCategory = async (categoryId, data) => {
  const categoryRef = doc(db, 'categories', categoryId);
  return await updateDoc(categoryRef, data);
};

export const deleteCategory = async (categoryId) => {
  return await deleteDoc(doc(db, 'categories', categoryId));
};

export const initializeDefaultCategories = async (userId) => {
  const promises = DEFAULT_CATEGORIES.map(category => 
    createCategory(userId, category)
  );
  return await Promise.all(promises);
};
